import { useUserDataContext } from "contexts/UserDataContext/UserDataContext";
import { LOADING } from "graphql/helpers/queryHelpers";
import { useCluster } from "in_queue/contexts/ClusterContext";
import { useSubscriptionForCluster } from "in_queue/contexts/ProjectDataContext";
import { ScenarioStage } from "in_queue/types/scenarioType";
import { clusterStatusFromSubscription } from "in_queue/utils/clusterStatus";
import { doesClusterAllowScenarioCreation } from "in_queue/utils/scenarios";
import { ADMIN_TYPE } from "types/roleType";
import { useIsAtScenarioLimit } from "./useIsAtScenarioLimit";

/**
 * Determine if the user can create scenarios. They can do so if:
 * 1. They are an admin
 * 2. They have not exceeded the number of scenarios allowed by their subscription
 * 3. Scenario creation is enabled based on the cluster status
 * @returns Boolean
 */
export const useIsScenarioCreationEnabled = ({
    stage
}: {
    stage: ScenarioStage;
}): boolean => {
    const { role } = useUserDataContext();
    const subscription = useSubscriptionForCluster();
    const cluster = useCluster();
    const isAtScenarioLimit = useIsAtScenarioLimit();
    if (subscription === LOADING || !subscription || !cluster) {
        return false;
    }
    const clusterStatus = clusterStatusFromSubscription(cluster, subscription);
    const isAdmin = role === ADMIN_TYPE;
    const scenarioStageAllowsCreation = doesClusterAllowScenarioCreation(
        clusterStatus,
        stage
    );
    return isAdmin && !isAtScenarioLimit && scenarioStageAllowsCreation;
};
